import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { TestimonialsCarousel, PageSection } from '@gik/ui';
import { testimonials } from '@gik/marketing/testimonials';

export default function TestimonialsCarouselSection(): React.ReactElement {
  const bem = bemBlock('testimonials-carousel-section');
  return (
    <PageSection className={bem()}>
      <TestimonialsCarousel variant="secondary" items={testimonials} />
    </PageSection>
  );
}
